import { render, staticRenderFns } from "./LandLogistic.vue?vue&type=template&id=21777b79&"
import script from "./LandLogistic.vue?vue&type=script&lang=js&"
export * from "./LandLogistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports